var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.carregando)?_c('carregando'):_vm._e(),_vm._v(" "),(_vm.erro)?_c('div',{staticClass:"ibox float-e-margins"},[_c('div',{staticClass:"ibox-content text-center"},[_c('h2',[_vm._v("Assinatura Eletrônica")]),_vm._v(" "),_c('div',{staticClass:"alert alert-warning no-margin-bottom"},[_vm._v("\n        "+_vm._s(_vm.erro)+"\n      ")])])]):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3846724c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./FrontEnd/modulos/assinatura-embed/componentes/Sessao.vue
// module id = 1964
// module chunks = 0